<template>
    <a-layout id="layout-ops">
        <a-layout-sider v-model="collapsed" :trigger="null" collapsible>
            <div class="logo"></div>
            <a-menu theme="dark" mode="inline" :open-keys.sync="menuPaths" :selected-keys="menuIndex" @click="execMenuSelete">
                <template v-for="item in menus">
                    <a-menu-item :key="item.code" v-if="item.subs === undefined" v-has="item.role" :title="item.name">
                        <a-icon :type="item.icon || 'appstore'" />
                        <span>{{ item.name }}</span>
                    </a-menu-item>
                    <a-sub-menu v-else v-has="item.role" :key="item.code">
                        <span slot="title">
                            <a-icon :type="item.icon || 'appstore'" />
                            <span>{{ item.name }}</span>
                        </span>
                        <template v-for="sub in item.subs">
                            <a-menu-item v-if="sub.subs === undefined" v-has="sub.role" :key="sub.code" :title="sub.name">
                                <a-icon :type="sub.icon || 'appstore'" />
                                <span>{{ sub.name }}</span>
                            </a-menu-item>
                            <a-sub-menu v-else v-has="sub.role" :key="sub.code">
                                <template slot="title">
                                    <a-icon :type="sub.icon || 'appstore'" />
                                    <span slot="title">{{ sub.name }}</span>
                                </template>
                                <template v-for="sub2 in sub.subs">
                                    <a-sub-menu v-has="sub2.role" :key="sub2.code">
                                        <template slot="title">
                                            <a-icon :type="sub2.icon || 'appstore'" />
                                            <span slot="title">{{ sub2.name }}</span>
                                        </template>
                                    </a-sub-menu>
                                </template>
                            </a-sub-menu>
                        </template>
                    </a-sub-menu>
                </template>
            </a-menu>
        </a-layout-sider>
        <a-layout>
            <a-layout-header :style="{ position: 'fixed', zIndex: 1, width: collapsed ? 'calc(100vw - 80px)' : 'calc(100vw - 200px)', padding: 0, color: '#fff' }">
                <div :style="{ display: 'flex', 'align-items': 'center', 'justify-content': 'space-between' }">
                    <a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="execToggleMenu" />
                    <a-dropdown :style="{ marginRight: '20px' }">
                        <a class="ant-dropdown-link" :style="{ color: 'white' }" @click="e => e.preventDefault()">
                            欢迎您，{{ user.name }}
                            <a-icon type="down" />
                        </a>
                        <a-menu slot="overlay" @click="execDropdownClick">
                            <!-- <a-menu-item key="profile">
                                <a-icon type="profile" />
                                个人设置
                            </a-menu-item>
                            <a-menu-item key="users">
                                <a-icon type="wechat" />
                                绑定账户
                            </a-menu-item>
                            <a-menu-divider />
                            <a-menu-item key="message">
                                <a-icon type="message" />
                                我的消息
                            </a-menu-item>
                            <a-menu-divider />
                            <a-menu-item key="help">
                                <a-icon type="question-circle" />
                                帮助中心
                            </a-menu-item>
                            <a-menu-divider /> -->
                            <a-menu-item key="logout">
                                <a-icon type="logout" />
                                注销登录
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </div>
            </a-layout-header>
            <a-layout-content :style="{ paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', marginTop: '74px', marginLeft: '10px', marginRight: '10px' }">
                <div :style="{ height: '100%', minHeight: '280px' }">
                    <div :style="{ padding: '24px', background: '#fff' }">
                        <router-view></router-view>
                    </div>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>
<style>
#layout-ops {
    height: 100vh !important;
}
#layout-ops .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
}

#layout-ops .trigger:hover {
    color: #1890ff;
}

#layout-ops .logo {
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    margin: 16px;
}
</style>
<script>
import menus from '@/router/menu'

export default {
    name: 'Main',
    data() {
        return {
            collapsed: sessionStorage.getItem('App.MenuCollapsed') === 'true' || false,
            menus: menus,
            menuIndex: JSON.parse(sessionStorage.getItem('App.MenuKey') || '["ui.index"]'),
            menuPaths: JSON.parse(sessionStorage.getItem('App.MenuPaths') || '[]')
        }
    },
    computed: {
        user() {
            return this.$store.state.User
        }
    },
    watch: {
        $route(to) {
            if (!to.name.startsWith('ui.') || to.name === 'ui.index') {
                let paths = []
                let arr = to.name.split('.')
                for (let i = 0; i < arr.length - 1; i++) {
                    let temp = ''
                    for (let x = 0; x < i; x++) {
                        temp += arr[x] + '.'
                    }
                    paths[paths.length] = temp + arr[i]
                }
                this.menuIndex = [to.name]
                this.menuPaths = paths
                sessionStorage.setItem('App.MenuKey', JSON.stringify([to.name]) || '["ui.index"]')
                sessionStorage.setItem('App.MenuPaths', JSON.stringify(paths) || '[]')
            } else {
                this.menuIndex = ['ui.index']
                this.menuPaths = []
                sessionStorage.setItem('App.MenuKey', '["ui.index"]')
                sessionStorage.setItem('App.MenuPaths', '[]')
            }
        }
    },
    methods: {
        execMenuSelete(item) {
            if (item.key === this.$route.name) {
                return
            }
            sessionStorage.setItem('App.MenuKey', JSON.stringify([item.key]))
            if (item.key === 'ui.index') {
                sessionStorage.setItem('App.MenuPaths', '[]')
            } else {
                sessionStorage.setItem('App.MenuPaths', JSON.stringify(item.keyPath.splice(0, 1)))
            }
            this.$router.push({
                name: item.key
            })
        },
        execToggleMenu() {
            this.collapsed = !this.collapsed
            sessionStorage.setItem('App.MenuCollapsed', this.collapsed)
        },
        execDropdownClick(cmd) {
            if (cmd.key === 'logout') {
                this.$confirm({
                    title: '提示',
                    content: '是否注销当前登录用户？',
                    okText: '注销登录',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk: () => {
                        this.$http
                            .post('/ums/user/login/signout', {
                                uid: this.user.id
                            })
                            .then(result => {
                                if (result.code === 0) {
                                    this.$store.commit('signout')
                                    this.$router.push({
                                        name: 'guest.login'
                                    })
                                }
                            })
                    }
                })
            }
        }
    }
}
</script>
